/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import * as Spinners from '@Services/Spinners';
import isNaN from 'lodash/isNaN';
import each from 'lodash/each';
import './Spinner.scss';
import PropTypes from 'prop-types';

const SPINNER_SIZE = {
  width: 2.375,
  height: 2.375,
};

const DEFAULT_SCALE = 1.5;

function Spinner({ spinnerId, spinnerClass, spinnerScale = DEFAULT_SCALE, position = 'absolute', autoStart, displayOverlay }) {
  const [isVisible, setIsVisible] = useState(false);
  const spinnerRef = useRef(null);

  const getScaleSize = (spinnerScaleArg) => {
    let scale = Number(spinnerScaleArg);
    if (isNaN(scale)) {
      scale = DEFAULT_SCALE;
      Logger.warn(`RxSpinner: specified scale "${spinnerScaleArg}" is not supported. Default one was used instead.`);
    }

    const styles = {};
    // eslint-disable-next-line no-return-assign
    each(SPINNER_SIZE, (value, key) => (styles[key] = `${value * scale}rem`));
    return styles;
  };

  const toggleState = (state) => {
    setIsVisible(state);
    if (displayOverlay) {
      const overlayElement = spinnerRef.current.querySelector('.spinner-overlay');
      if (overlayElement) {
        overlayElement.style.display = state ? 'block' : 'none';
      }
    }
  };

  useEffect(() => {
    const spinnerElement = spinnerRef.current;
    const scale = getScaleSize(spinnerScale);

    // Apply the spinner class and styles
    const spinnerClassAdd = `${spinnerClass || 'search-sync-icon'}`;
    const loaderClassAdd = `rx-loader--container__${position}`;
    spinnerElement.classList.add(spinnerClassAdd);
    spinnerElement.classList.add(loaderClassAdd);
    const spinnerAnimation = spinnerElement.querySelector('.spinner-animation');
    Object.assign(spinnerAnimation.style, scale);

    // Register the spinner with the Spinners service
    Spinners.register(spinnerId, toggleState);

    // Auto-start the spinner if the prop is provided
    if (autoStart) {
      Spinners.activate(spinnerId);
    }

    // Cleanup on component unmount
    return () => {
      Spinners.unregister(spinnerId);
    };
  }, [spinnerId, spinnerClass, spinnerScale, position, autoStart]);

  return (
    <div
      ref={spinnerRef}
      className="rx-loader--container"
      style={{ display: isVisible ? 'block' : 'none' }}
      aria-hidden="false"
      aria-label="loading content"
      role="status">
      {displayOverlay && <div className="spinner-overlay spinner-overlay-css" />}

      <div className="spinner-animation" />
    </div>
  );
}

Spinner.propTypes = {
  spinnerId: PropTypes.string,
  spinnerClass: PropTypes.string,
  spinnerScale: PropTypes.number,
  position: PropTypes.string,
  autoStart: PropTypes.bool,
  displayOverlay: PropTypes.bool,
};

export default Spinner;
